import type { RefObject } from "react";
import { THEME_PREVIEW_FRAME_NAME } from "utils/theme-preview-storage";

type ThemeSetterRightPanelProps = {
  normalizedCustomer: string;
  previewUrl: string;
  iframeRef: RefObject<HTMLIFrameElement | null>;
  onPreviewLoad: () => void;
};

export const ThemeSetterRightPanel = ({
  normalizedCustomer,
  previewUrl,
  iframeRef,
  onPreviewLoad,
}: ThemeSetterRightPanelProps) => {
  return (
    <div className="hidden lg:flex flex-col w-1/3 lg:h-full lg:overflow-hidden">
      <div className="space-y-2 flex-shrink-0">
        <p className="text-sm uppercase text-primary">Live Preview</p>
        <h1 className="text-3xl font-semibold">Project surface</h1>
        <p className="text-gray-300 text-sm leading-relaxed">
          You're viewing the{" "}
          <strong className="uppercase">"{normalizedCustomer}"</strong> live
          preview.
        </p>
      </div>

      <div className="mt-4 flex-1 flex items-center justify-center">
        {previewUrl ? (
          <div className="relative w-full rounded-2xl border-4 border-gray-600 bg-gray-800 px-1 shadow-2xl">
            <div className="relative h-[70vh] rounded-xl">
              <iframe
                ref={iframeRef}
                key={previewUrl}
                src={previewUrl}
                title="Theme preview"
                name={THEME_PREVIEW_FRAME_NAME}
                className="h-full w-full rounded-xl"
                loading="lazy"
                onLoad={onPreviewLoad}
              />
            </div>
          </div>
        ) : (
          <div className="p-6 text-sm text-gray-300">
            Preview is unavailable in this environment.
          </div>
        )}
      </div>
      <p className="mt-4 text-sm text-gray-400 flex-shrink-0">
        The frame renders the actual application. Changes in the editor are
        mirrored in the preview when the configuration updates.
      </p>
    </div>
  );
};
